import { TFunction } from 'i18next';

import { STATUS_COLORS } from '../../constants';
import { IMetricThresholdDetailsData, IStatusLegendItem } from '../types';

export function buildThresholdLegend(
  t: TFunction,
  live: IMetricThresholdDetailsData,
  higherIsBetter: boolean
): IStatusLegendItem[] {
  const [lo, hi] = live.breakpoints;
  const good = {
    color: STATUS_COLORS.good.fill,
    label: t('legendGood', { value: higherIsBetter ? hi : lo }),
  };
  const ok = {
    color: STATUS_COLORS.ok.fill,
    label: t('legendOk', { low: lo, high: hi }),
  };
  const poor = {
    color: STATUS_COLORS.poor.fill,
    label: t('legendPoor', { value: higherIsBetter ? lo : hi }),
  };
  return higherIsBetter ? [poor, ok, good] : [good, ok, poor];
}
